<!--
* @Name：跨组织调拨基本页面
* @Author: 王超
* @Date: 2022-03-09
-->
<template>
  <div>
    <hi-cell title="调拨单号：" :value="headInfo.applyCode"></hi-cell>
    <hi-cell title="申请标题：" :value="headInfo.applyTitle"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.applyUserName"></hi-cell>
    <hi-cell title="申请时间：" :value="headInfo.applyTime"></hi-cell>
    <hi-cell title="调出公司：" :value="headInfo.outCorpFullName"></hi-cell>
    <hi-cell title="调出仓库：" :value="headInfo.outStorageSiteName"></hi-cell>
    <hi-cell title="调入公司：" :value="headInfo.inCorpFullName"></hi-cell>
    <hi-cell title="调入仓库：" :value="headInfo.inStorageSiteName"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {}
}
</script>
